import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView    from "./TemplateListView";
import ModelObjAdminDetailsView from "./ModelObjAdminDetailsView";
import ModelObjAdminNewView     from "./ModelObjAdminNewView";


const ModelObjAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "ModelObjAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'id',
      name: t("I18N_Mapping_id"),
      sortable: true,
      sortField: 'id',
      cell: null
    },
    {
      name: t("I18N_Model_elem_id"),
      selector: row => row.modelElemId,
      sortable: true,
      sortField: 'modelElemId',
    },
    {
      name: t("I18N_Obj_id"),
      selector: row => row.objId,
      sortable: true,
      sortField: 'objId',
    },
    {
      name: t("I18N_Obj_type"),
      selector: row => row.objType,
      sortable: true,
      sortField: 'objType',
    },
    {
      name: t("I18N_Location_code"),
      selector: row => row.locationCode,
      sortable: true,
      sortField: 'locationCode',
    },
    {
      name: t("I18N_BIM_GUID"),
      selector: row => row.bimGuid,
    },
    {
      name: t("I18N_BIM_Element_id"),
      selector: row => row.bimElementId,
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API} apiObjName={'model-obj-mappings'}
                                                  listPageTitle={t("I18N_ModelObjMap_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_model_obj_mapping")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_3dModelObj_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_model_obj_mapping")}
                                                  deleteObjNameField={"id"}
                                                  tableColumns={tableColumns}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <ModelObjAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <ModelObjAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default ModelObjAdmin;
